<template>
    <app-layout :title="'Order history for ' + $page.props.tenant.name">
        <template v-slot:header>
            <div class="flex justify-between">
                <h2 class="font-semibold text-xl text-gray-800 dark:text-gray-200 leading-tight">
                    Order Success
                </h2>
            </div>
        </template>
        <div class="w-full overflow-hidden rounded-lg">
            <h4 class="mb-2 text-lg font-semibold text-gray-600 dark:text-gray-300">
                Thank you for your purchase!
            </h4>
            <div class="mb-2 text-gray-600 dark:text-gray-300">
                Order #{{ order.id }} has been successfully completed.<br/>
                The survey's "{{ order.survey.name }}" status is <pill type="success" class="text-xs">{{ order.survey.current_status }}</pill>.
            </div>

            <div class="mb-2 text-gray-600 dark:text-gray-300">
                You can invite additional respondents using the link below:
            </div>
            <div class="mb-2 font-semibold text-gray-600 dark:text-gray-300 flex align-middle">
                {{ surveyUrl }}
                <button title="Copy survey URL"
                        @click.prevent="copyToClipboard(survey)"
                        class="ml-1 px-1">
                    <svg  xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-purple-600 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                    </svg>
                </button>
            </div>

            <div class="flex content-center">
                <inertia-link :href="route('tenant.survey.index', {tenant: order.tenant_id})"
                              class="px-4 py-2 font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple disabled:opacity-25 transition ml-auto flex items-center justify-center mt-8 px-5 py-3 font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-purple">
                    Continue
                </inertia-link>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import Pill from "@/Jetstream/Pill";
import useClipboard from "vue-clipboard3";
import {inject} from "vue";

export default {
    name: "Index",
    components: {
        Pill,
        AppLayout
    },
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const surveyUrl = props.order.survey.custom_url
            ? route('tenant.survey.fill.custom_url', {tenant: props.order.tenant_id, customUrl: props.order.survey.custom_url})
            : route('tenant.survey.fill.token', {tenant: props.order.tenant_id, token: props.order.survey.token});

        const {toClipboard} = useClipboard();

        const $toast = inject('$toast');

        const copyToClipboard = async () => {
            let urlString;
            try {
                if (props.order.survey.custom_url) {
                    urlString = route('tenant.survey.fill.custom_url', {
                        tenant: props.order.survey.tenant_id,
                        customUrl: props.order.survey.custom_url,
                    });
                } else {
                    urlString = route('tenant.survey.fill.token', {
                        tenant: props.order.survey.tenant_id,
                        token: props.order.survey.token,
                    });
                }
                await toClipboard(urlString);
                $toast('Copied to clipboard', {type: "success"});
            } catch (e) {
                console.error(e)
            }
        };

        return {
            surveyUrl,
            copyToClipboard
        }
    }
}
</script>

<style scoped>

</style>
